import { runtimeEnvKeys } from '../declaration/runtime.mjs';
import { buildtimeEnvKeys } from '../declaration/buildtime.mjs';

const getInitialEnvValue = (envKeys) => envKeys.reduce(
  (acc, cur) => ({ ...acc, [cur]: "" }),
  {}
);
const runtimeEnvInitialValue = getInitialEnvValue(runtimeEnvKeys);
const buildtimeEnvInitialValue = getInitialEnvValue(buildtimeEnvKeys);

export { buildtimeEnvInitialValue, runtimeEnvInitialValue };
//# sourceMappingURL=initialValue.mjs.map
